import { createFileRoute } from "@tanstack/react-router";
import { IndustriPage, industriHead } from "@/pages/IndustriPage";

export const Route = createFileRoute("/en/industries/industry-manufacturing")({
  head: () => industriHead("en"),
  component: () => <IndustriPage locale="en" />,
});
